// Angular imports
import { Component } from '@angular/core';

// Import message service
import { MessageService, MessageOptions, MessageType, ButtonHandler } from '../services/message.service';

@Component({
    selector: 'message-container',
    templateUrl: './message-container.component.html',
    styleUrls: ['./message-container.component.scss'],
    standalone: false
})
export class MessageContainerComponent {
    // Container properties
    public _messageShown: boolean = false;

    // Message properties
    public _title: string = '';
    public _message: string = '';
    public _type: MessageType = MessageType.Info;
    public _buttons: ButtonHandler[];
    private closeHandler: () => void;

    constructor(private messageService: MessageService) {
        this.messageService._requestMessageShow.subscribe((options) => {
            // Init
            this.init(options);

            // Show message
            this._messageShown = true;
        });

        this.messageService._requestMessageHide.subscribe(() => {
            // Hide message
            this._messageShown = false;
        });
    }

    private init(args: MessageOptions) {
        this._title = args.title;
        this._message = args.message;
        this._type = args.type || MessageType.Info;
        this.closeHandler = args.closeHandler;
        this._buttons = args.buttons || [{ text: 'Ok' }];
    }

    /* --- Event handlers --- */

    public async _handleClickButton(button: ButtonHandler) {
        // Trigger handler
        let shouldTriggerCloseHandler = true;
        if (button.handler) {
            const result = button.handler();

            shouldTriggerCloseHandler = (result instanceof Promise ? (await result) : result) !== false;
        }

        // Close if needed
        if (shouldTriggerCloseHandler)
            this._close();
        else
            this.messageService.hide();
    }

    public _close() {
        // Trigger close handler if needed
        if (this.closeHandler)
            this.closeHandler();

        // Hide the message
        this.messageService.hide();
    }
}
